export const WELCOME_VIDEO_URL = 'https://www.youtube.com/watch?v=dwnGovqM23E';
export const TRAINING_TYPEFORM_URL = 'https://joinuplift.typeform.com/to/jbFfLUtb';

export const REGULAR_PROGRESS_THRESHOLDS = [ 0, 5, 10, 40, 70, 100 ];
export const MSO_PROVIDER_PROGRESS_THRESHOLDS = [ 0, 0, 5, 10, 55, 100 ]; // matching availability is not required for MSO partners and is auto-approved
